import React from "react";
import { branchColor } from "../../pages/ProjectFinanceDetail";
import { REGION_LABELS } from "../ScopeSelect";
import { applyCoFilters } from "./CoQuickFilters";

const money = (n) => "$" + Math.round(Number(n || 0)).toLocaleString();
const amt = (co) => Number(co.approvedPrice || co.estimatedPrice || 0);
const sum = (rows) => rows.reduce((s, co) => s + amt(co), 0);

/* 变更单 · 分公司汇总条：按当前其它筛选（搜索 / 阶段 / 施工锁 / 销售 / 时间）统计各分公司 单数 + 金额；点击切换分公司筛选 */
export const CoBranchStrip = ({ zh, params, setParams, list }) => {
  const p = new URLSearchParams(params); p.delete("region");
  const rows = applyCoFilters(list, p);
  const active = params.get("region") || "";
  const regions = ["la", "norcal", "sd"].filter((r) => rows.some((co) => co.region === r) || r === active);
  const other = rows.filter((co) => !co.region);
  const setRegion = (r) => { const q = new URLSearchParams(params); if (!r || active === r) q.delete("region"); else q.set("region", r); setParams(q, { replace: true }); };
  const label = (r) => (REGION_LABELS[r] || {})[zh ? "zh" : "en"] || r;
  return (
    <div className="flex flex-wrap gap-2" data-testid="co-branch-strip" data-count={rows.length}>
      <button type="button" data-testid="co-branch-chip-all" onClick={() => setRegion("")}
        className={`rounded-xl border px-4 py-2.5 text-left transition-colors ${!active ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-600 hover:border-slate-400"}`}>
        <p className="text-[11px] font-medium opacity-80">{zh ? "全部分公司" : "All branches"}</p>
        <p className="text-sm font-bold mt-0.5 tabular-nums">{rows.length} {zh ? "单" : "COs"} · {money(sum(rows))}</p>
      </button>
      {regions.map((r) => {
        const rs = rows.filter((co) => co.region === r);
        const on = active === r;
        const clr = branchColor(r, label(r));
        return (
          <button key={r} type="button" data-testid={`co-branch-chip-${r}`} data-count={rs.length} onClick={() => setRegion(r)}
            className={`rounded-xl border px-4 py-2.5 text-left transition-colors ${on ? "text-white" : "bg-white hover:opacity-90"}`}
            style={on ? { background: clr, borderColor: clr } : { borderColor: clr + "66" }}>
            <p className="text-[12px] font-bold flex items-center gap-1.5" style={on ? {} : { color: clr }}>
              <span className="w-2 h-2 rounded-full inline-block" style={{ background: on ? "#fff" : clr }} />{label(r)} · {rs.length} {zh ? "单" : ""}
            </p>
            <p className={`text-[11px] mt-0.5 tabular-nums ${on ? "text-white/90" : "text-slate-500"}`}>
              {zh ? "金额" : "Amount"} <span className="font-semibold">{money(sum(rs))}</span>
              {rs.some((co) => co.approvedPrice) && <> · {zh ? "已批" : "Approved"} <span className="font-semibold">{money(rs.reduce((s, co) => s + Number(co.approvedPrice || 0), 0))}</span></>}
            </p>
          </button>
        );
      })}
      {other.length > 0 && (
        <div data-testid="co-branch-chip-other" className="rounded-xl border border-dashed border-slate-300 px-4 py-2.5 text-slate-500">
          <p className="text-[12px] font-bold">{zh ? "未归属分公司" : "No branch"} · {other.length}</p>
          <p className="text-[11px] mt-0.5 tabular-nums">{money(sum(other))}</p>
        </div>
      )}
    </div>
  );
};
